import { track } from 'src/tracking/analytics';

export const linkWasClicked = (href, description) => track('Link was clicked', { href, ...(description ? { description } : {}) });
